import cn from "classnames";
import "./TextDash.css";
import type { ComponentPropsWithRef, FC } from "react";

type TextDashProps = ComponentPropsWithRef<"div"> & {
	variant?: "primary" | "gray";
};

/**
 * A text with a dash on both sides like ths: ---- Text ----
 */
export const TextDash: FC<TextDashProps> = (props) => {
	const { className, variant = "gray", ...rest } = props;

	const classes = cn("text-dash", variant, className);

	return <div className={classes} {...rest} />;
};
